var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99854 1.35547C9.25926 1.35547 9.49139 1.50919 9.57699 1.73851L11.0985 5.81456H9.80177L8.99854 3.66269L7.60233 7.40313C7.51824 7.62844 7.29245 7.7812 7.03636 7.78606L2.78481 7.86674L6.17346 10.2591C6.37757 10.4032 6.46381 10.6504 6.38964 10.8787L5.15824 14.669L8.64874 12.4072C8.85899 12.2709 9.13808 12.2709 9.34833 12.4072L12.8388 14.669L11.6074 10.8787C11.5333 10.6504 11.6195 10.4032 11.8236 10.2591L15.2123 7.86674L10.5385 7.82323L10.0736 6.67425L16.9987 6.75983C17.2593 6.76477 17.4881 6.92286 17.5686 7.15377C17.6492 7.38467 17.5639 7.63776 17.3562 7.78444L12.9032 10.9283L14.5213 15.9091C14.5968 16.1415 14.5061 16.3929 14.2951 16.5356C14.0842 16.6783 13.7994 16.681 13.5854 16.5423L8.99854 13.5701L4.41169 16.5423C4.19768 16.681 3.91286 16.6783 3.70193 16.5356C3.491 16.3929 3.40023 16.1415 3.47573 15.9091L5.0939 10.9283L0.640898 7.78444C0.433138 7.63776 0.347881 7.38467 0.428448 7.15377C0.509015 6.92286 0.737739 6.76477 0.998404 6.75983L6.58534 6.6538L8.42008 1.73851C8.50568 1.50919 8.73782 1.35547 8.99854 1.35547Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.7781292d28839412fbeb756a85a1acca.svg";
export { ForwardRef as ReactComponent };